import { Defect } from '@/types/Defecten';
import { MaterieelType } from '@/types/werklijnenInline';

// Soorten die een koppelteken bevatten en geen aparte aanduiding hebben.
const HYPHENATED_SOORTEN = new Set(['E-LOC']);

export const splitMaterieelType = (materieelType: string | undefined): MaterieelType => {
  const trimmedMaterieelType = materieelType?.trim() ?? '';
  if (!trimmedMaterieelType) {
    return { soort: '', aanduiding: '' };
  }
  if (HYPHENATED_SOORTEN.has(trimmedMaterieelType.toUpperCase())) {
    return { soort: trimmedMaterieelType, aanduiding: '' };
  }
  const [soort, ...rest] = trimmedMaterieelType.split('-');
  return {
    soort: soort?.trim() ?? '',
    aanduiding: rest.join('-').trim(),
  };
};

/**
 * Bepaalt waar het materieeltype van een LMM-defect vandaan komt: de soort op het defect zelf,
 * anders het materieel van de voorraadregel. Eén bron voor zowel de klikbaarheid van een rij als
 * het paneel dat erna opent, zodat die twee niet uit elkaar kunnen lopen.
 */
export const lmmMaterieelBron = (materieelSoort?: string | null, voorraadMaterieel?: string): string =>
  materieelSoort?.trim() || voorraadMaterieel?.trim() || '';

/**
 * Een defectregel opent het materieelpaneel, ongeacht het gekozen tijdstip. Zonder eenheidnummer of
 * materieeltype valt er niets te tonen, dus blijft de regel niet-interactief.
 */
export const isLmmDefectKlikbaar = (defect: Defect, voorraadMaterieel?: string): boolean =>
  !!defect.eenheidNummer && !!lmmMaterieelBron(defect.materieelSoort, voorraadMaterieel);
